import {Injectable} from '@angular/core';
import {environment} from "../../environments/environment";
import { jwtDecode } from 'jwt-decode';
const {USER_KEY} = environment;

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  constructor() {
  }

  clean(): void {
    var uuid = localStorage.getItem("uuid");
    // console.log("Browser:",uuid);
    localStorage.clear();
    localStorage.setItem("uuid", uuid ?? "");
    uuid = localStorage.getItem("uuid");
    // console.log("Browser 2:",uuid);
  }

  public saveUser(user: any): void {
    localStorage.removeItem(USER_KEY);
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  }

  public getUser(): any {
    const user = localStorage.getItem(USER_KEY);
    if (user) {
      return JSON.parse(user);
    }
    return {};
  }

  public getUserName(): any {
    const user = localStorage.getItem('user');
    if (user) {
      return user;
    }
    return {};
  }

  public isLoggedIn(): boolean {
    const user = localStorage.getItem(USER_KEY);
    // console.log("StorageService isLoggedIn() Called............");
    // console.log(!!user);
    
    
    return !!user;

  }

  public setName(token:any){
    const decoded: any = jwtDecode(token);
    localStorage.setItem("username",decoded.username)
  }

  public getToken(): string {
    const user: any = localStorage.getItem(USER_KEY);
    const userObj = JSON.parse(user);
    return userObj?.accessToken || userObj?.token || null
  }

  public saveMenuItems(data:any): any{
    localStorage.setItem('menuItems', JSON.stringify(data));
  }

  public getMenuItems(): any{
    const menuString = localStorage.getItem('menuItems');
    return JSON.parse(menuString || "{}");
  }

  isJwtExpired(): boolean {
    try {
      const decoded: any = jwtDecode(this.getToken());
      // console.log(decoded)
      const currentTime = Date.now() / 1000;
      return decoded.exp < currentTime;
    } catch (error) {
      console.error("Invalid JWT:", error);
      return true; 
    }
  }
}
